// Capitalises the first letter of a string, finding the first actual letter (skipping numbers/symbols)
export function capitaliseFirstLetter (text: string | null | undefined): string {
  if (!text) {
    return text ?? ''
  }

  const trimmed = text.trimStart()
  if (!trimmed) {
    return text
  }

  // Find the first letter (skip numbers/symbols)
  const firstLetterIndex = trimmed.search(/[a-zA-Z]/)
  if (firstLetterIndex === -1) {
    return text
  }

  const leadingWhitespace = text.slice(0, text.length - trimmed.length)
  const beforeLetter = trimmed.slice(0, firstLetterIndex)
  const letter = trimmed.charAt(firstLetterIndex).toUpperCase()
  const afterLetter = trimmed.slice(firstLetterIndex + 1)

  return leadingWhitespace + beforeLetter + letter + afterLetter
}

// Removes a trailing full stop from a label, unless it is part of an abbreviation (e.g. "U.K.", "e.g.")
export function stripTerminalFullStop (text: string): string {
  const trimmed = text.trimEnd()
  if (!trimmed.endsWith('.') || trimmed.length <= 2) {
    return text
  }
  const withoutFinal = trimmed.slice(0, -1)
  if (withoutFinal.includes('.')) {
    return text
  }
  return withoutFinal
}
